import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './../assets/images/logo.png';

export default class TAGZYMEGR extends Component {
  render() {
    return (
      <div className="container my-4 notification-100">

        <header className="text-center">
          <img src={logo} alt="KREP" style={{ borderRadius: '8px' }} />
          <h1 className="mt-2">TAGZYME GR</h1>
        </header>

        {/* English Section */}
        <div className="section">
          <h3>English</h3>
          <ul>
            <li>
              <span className="label">1. Gazette Notification number and Date:</span> S.O.3922(E) Dated 12-09-2024
            </li>
            <li>
              <span className="label">Amendment gazette notification number and date:</span> S.O.876(E) Dated 16-02-2026
            </li>
            <li>
              <span className="label">2. Title of Biostimulant:</span> (2) Sargassum tenerrimum 2% (Granular)
            </li>
            <li>
              <span className="label">3. Composition:</span>
              <ul>
                <li>(i) Seaweed (Sargassum tenerrimum) extract per cent. by weight, minimum: 2.0</li>
                <li>(ii) Phytase as adjuvant per cent. by weight, maximum: 1.0</li>
                <li>(iii) Bentonite per cent. by weight, maximum: 87.0</li>
                <li>(iv) Moisture per cent. by weight, maximum: 10.0</li>
                <li>(v) Total (per cent.): 100.0</li>
              </ul>
            </li>
            <li>
              <span className="label">4. Crop:</span> Paddy and Tomato
            </li>
            <li>
              <span className="label">5. Doses:</span>
              <ul>
                <li>(i) Paddy: One soil application at 12.5 kg/ha</li>
                <li>(ii) Tomato: One soil application at 12.5 kg/ha</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Hindi Section */}
        <div className="section">
          <h3>हिन्दी</h3>
          <h4>टैगज़ाइम जीआर</h4>
          <ul>
            <li>
              <span className="label">1. राजपत्र अधिसूचना संख्या और तिथि:</span> S.O.3922(E) दिनांक 12-09-2024
            </li>
            <li>
              <span className="label">संशोधन राजपत्र अधिसूचना संख्या और तिथि:</span> S.O.876(E) दिनांक 16-02-2026
            </li>
            <li>
              <span className="label">2. जैव-उत्तेजक का शीर्षक:</span> (2) सरगास्सम टेनेर्रिमम 2% (दानेदार)
            </li>
            <li>
              <span className="label">3. संरचना:</span>
              <ul>
                <li>(i) समुद्री शैवाल (सरगास्सम टेनेर्रिमम) का अर्क (वजन के अनुसार प्रतिशत), न्यूनतम: 2.0</li>
                <li>(ii) फाइटेज (Phytase) सहायक के रूप में (वजन के अनुसार प्रतिशत), अधिकतम: 1.0</li>
                <li>(iii) बेंटोनाइट (वजन के अनुसार प्रतिशत), अधिकतम: 87.0</li>
                <li>(iv) नमी (वजन के अनुसार प्रतिशत), अधिकतम: 10.0</li>
                <li>(v) कुल (प्रतिशत): 100.0</li>
              </ul>
            </li>
            <li>
              <span className="label">4. फसल:</span> धान और टमाटर
            </li>
            <li>
              <span className="label">5. खुराक:</span>
              <ul>
                <li>(i) धान: 12.5 किग्रा/हेक्टेयर की दर से मिट्टी में एक बार प्रयोग</li>
                <li>(ii) टमाटर: 12.5 किग्रा/हेक्टेयर की दर से मिट्टी में एक बार प्रयोग</li>
              </ul>
            </li>
          </ul>
        </div>

        {/* Marathi Section */}
        <div className="section">
          <h3>मराठी</h3>
          <h4>टॅगझाइम जीआर</h4>
          <ul>
            <li>
              <span className="label">1. राजपत्र अधिसूचना क्रमांक आणि दिनांक:</span> S.O.3922(E) दिनांक 12-09-2024
            </li>
            <li>
              <span className="label">सुधारणा राजपत्र अधिसूचना क्रमांक आणि दिनांक:</span> S.O.876(E) दिनांक 16-02-2026
            </li>
            <li>
              <span className="label">2. जैव-उत्तेजकाचे शीर्षक:</span> (2) सरगास्सम टेनेर्रिमम 2% (दाणेदार)
            </li>
            <li>
              <span className="label">3. रचना:</span>
              <ul>
                <li>(i) सागरी शेवाळ (सरगास्सम टेनेर्रिमम) अर्क (वजनानुसार टक्केवारी), किमान: 2.0</li>
                <li>(ii) फायटेज (Phytase) सहाय्यक घटक म्हणून (वजनानुसार टक्केवारी), कमाल: 1.0</li>
                <li>(iii) बेंटोनाइट (वजनानुसार टक्केवारी), कमाल: 87.0</li>
                <li>(iv) ओलावा (वजनानुसार टक्केवारी), कमाल: 10.0</li>
                <li>(v) एकूण (टक्केवारी): 100.0</li>
              </ul>
            </li>
            <li>
              <span className="label">4. पीक:</span> भात आणि टोमॅटो
            </li>
            <li>
              <span className="label">5. मात्रा:</span>
              <ul>
                <li>(i) भात: 12.5 किग्रॅ/हेक्टर या प्रमाणात जमिनीतून एक वापर</li>
                <li>(ii) टोमॅटो: 12.5 किग्रॅ/हेक्टर या प्रमाणात जमिनीतून एक वापर</li>
              </ul>
            </li>
          </ul>
        </div>

      </div>
    );
  }
}